import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  shopImageContainer: {
    width: 80,
    height: 80,
    borderRadius: theme.borderRadius.m,
    overflow: 'hidden',
  },
  shopImage: {
    width: '100%',
    height: '100%',
  },
  shopImagePlaceholder: {
    width: '100%',
    height: '100%',
    backgroundColor: colors.backgroundL1,
  },
  shopInfoContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  address: {
    flexWrap: 'wrap',
  },
}));
